import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PaycheckCommunicationOption } from './paycheck-communication-option.interface';
import { PaycheckCommunicationOptionService } from './paycheck-communication-option.service';

const service = new PaycheckCommunicationOptionService();

export interface PaycheckCommunicationOptionState {
   paycheckCommunicationOptions: Array<PaycheckCommunicationOption>;
}

const PaycheckCommunicationOptionStore: Module<PaycheckCommunicationOptionState, StoreState> = {
   namespaced: true,
   state: { paycheckCommunicationOptions: [] },
   getters: {},
   mutations: {
      SET_PAYCHECK_COMMUNICATION_OPTIONS(state, paycheckCommunicationOptions: Array<PaycheckCommunicationOption>) {
         state.paycheckCommunicationOptions = paycheckCommunicationOptions;
      },
   },
   actions: {
      async getPaycheckCommunicationOptions(context) {
         const response = await service.getPaycheckCommunicationOptions();
         context.commit('SET_PAYCHECK_COMMUNICATION_OPTIONS', response.data);
         return response.data;
      },
   },
};

export default PaycheckCommunicationOptionStore;
